import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { queryClient } from '@/queries';
import { NewHubFormBody, PatchHubFormBody } from '@/api/apis/facilities';
import { hubsQueryKeys } from '@/queries/hub/hub.keys';

export const useCreateHubMutation = () => {
  return useMutation({
    mutationFn: (variables: NewHubFormBody & { id: string }) => api.hub.createHub(variables),
    meta: {
      invalidates: [hubsQueryKeys.getList()],
    },
  });
};

export const useUpdateHubMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchHubFormBody & { id: string }) => api.hub.updateHubById(variables),
    meta: {
      invalidates: [hubsQueryKeys.getList()],
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: hubsQueryKeys.getItem(variables.id) });
    },
  });
};
